import { LitElement, html } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import {
	updateCurrentInspection,
	savePhotos,
	deletePhotoById,
	deleteDrawingById,
	getUpdateInspectionPromise
} from "../actions/inspection.js";
import { SharedStyles } from "../styles/shared-styles.js";
import { CardStyles } from "../styles/card-styles.js";
import { add, del, contentCopy } from "../styles/icons.js";
import "../elements/inspx-ajax-image.js";
import "../elements/inspx-inspection-card.js";
import "../elements/inspx-db-images-container.js";
import { validateSchemaPart } from "../lib/inspxValidationModule.js";
import { computeParts, groupBy, createOverlay } from "../lib/helpers.js";
import { validateCurrentInspectionTab } from "../actions/validation.js";
import { InspxDialog } from "../elements/inspx-dialog.js";

class InspxInspection extends connect(store)(LitElement) {
	shouldUpdate(changedProps) {
		const r =
            (this.data && this.schema) ||
            (changedProps && changedProps.tab != this.tab) ||
            this.pageType === "images" ||
            this.pageType === "drawings";

		return r;
	}

	async updated(changedProps) {
		// if (this.pageType === "array" && changedProps.has("data") && changedProps.get("data") != undefined && !changedProps.has('tab') && this.data.length > changedProps.get("data").length) {

		// 	let list = this.shadowRoot.querySelector(".list");

		// 	await this.updateComplete;
		// 	let cld = list.children[list.children.length - 2];
		// 	let upd = await cld.updateComplete;
		// 	if (upd && cld.parts && cld.parts.length > 0) {

		// 		//	cld.scrollIntoView()
		// 	}
		// }

	}

	render() {
		return (this.__reset)
			? html``
			: html`
            ${SharedStyles}
            ${CardStyles}
            <style>
                :host {
                    height: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: flex-start;
                    padding : 10px;
                    overflow: visible;
                    background-color: var(--primary-color-variant2);
                }
            
                .list {
                    display: grid;
                    grid-gap: 20px;
                    grid-auto-flow: dense;
                    grid-template-columns: repeat(auto-fill, minmax(420px, max-content));
                    margin: 10px;
                    box-sizing: border-box;
                    flex-grow: 1;
                }

                .no-items-msg {
                    text-align: center;
                    width: 100%;
                }

                .flex .card {
                  width: auto;
                }

                .large-images {
                    --db-image-height: 300px;
                }

                .fab {
                    cursor: pointer;
                    position: fixed;
                    right: 40px;
                    background-color: var(--secondary-color);
                    bottom: 20px;
                    border-radius: 50%;
                    width: 42px;
                    height: 42px;
                    align-items: center;
                    display: flex;
                    justify-content: space-around;
                    fill: white;
                }

                .tall{
                    width: auto;
                    margin: 10px;
                }
				
				.array-card-buttons {
                    cursor: pointer;
                    padding: 0;
                    display: flex;
                    fill: var(--secondary-color);
                }

				.array-card-buttons > * {
					margin-left: 25px;
                }
                
                @media only screen and (max-width: 800px) {
                    .tall{
                        width: 100%;
                    }

                    .flex .card {
                        width: 100%;
                    }
                }

                @media only screen and (max-width: 460px) {
                    :host {
                        padding: 0;
                    }
                    
                    .list {
                        grid-template-columns: repeat(auto-fill, minmax(300px, 440px));
                    }
                }

                #scrollPlaceholder{
                    width: 1px;
                    height: 1px;;
                }
            </style>
            
            ${this.renderFunctions[this.pageType]()}`;
	}

	renderImages() {
		//lastRendered makes lit-html rerender because other dependencies of inspx-db-images-container never change.
		const lastRenderd = new Date().getTime();
		return html`
            <inspx-db-images-container class="list large-images" hideAddPhoto all .lastRendered="${lastRenderd}" .inspectionid="${this.inspId}">
            </inspx-db-images-container>`;
	}

	renderDrawings() {
		//lastRendered makes lit-html rerender because other dependencies of inspx-db-images-container never change.
		const lastRenderd = new Date().getTime();
		return html`
            <inspx-db-images-container class="list large-images" hideAddPhoto all drawing .lastRendered="${lastRenderd}"
                .inspectionid="${this.inspId}">
            </inspx-db-images-container>`;
	}

	renderArray() {
		if (!this.data) return;

		if (this.data.length === 0) {
			return html`
                <p class="no-items-msg">No items added. Use '+' button at bottom right to add new item.</p>
                <div class="fab" @click="${() => this.addArrayItem()}">${add}</div>`;
		}

		return html`
            <div class="list">
                ${this.data.map((item, ind) => this.renderArrayItem(item, ind))}
                <div id="scrollPlaceholder"></div>
                <div class="fab" @click="${() => this.addArrayItem()}">${add}</div>
            </div>`;
	}

	renderArrayItem(item, ind) {
		if (!this.schema || !this.schema.items) return;

		const pathPrefix = this.tab + '.' + ind;
		const disablePhotos = this.schema.items.disablePhotos || false;
		const disableItemCopying = this.schema.items.disableItemCopying || false;
		const copyButton = !disableItemCopying
			? html`<div title="Copy Item" @click="${() => this.copyArrayItem(item, ind)}">${contentCopy}</div>`
			: '';
		const cardTitle = this.schema.items.showIndex
			? this.schema.items.title + " " + (ind + 1)
			: this.schema.items.title;

		return html`
            <inspx-inspection-card class="card" ?disablePhotos="${disablePhotos}" .inspId="${this.inspId}" .cardtitle="${cardTitle}"
                .data="${item}" .parts="${computeParts(this.schema.items)}" .pathprefix="${pathPrefix}" .invalidFields="${this.validation.invalidFields}">
                <div class="array-card-buttons">
                    ${copyButton}
                    <div title="Delete Item" @click="${() => this.openDeleteArrayItemConfigration(item, ind)}">${del}</div>
                </div>
            </inspx-inspection-card>`;
	}

	renderObject() {
		let parts = computeParts(this.schema);
		let gr = groupBy(parts, p => !!p.tall);
		let tall = gr.get(true) || [];
		let regular = gr.get(false) || [];
		let css = tall.length > 0 ? 'flex' : "";

		return html`
            ${tall.map(a => this.renderObjectItem(a, "tall"))}
            <div class="list ${css}">
                ${regular.map(a => this.renderObjectItem(a))}
            </div>`;
	}

	renderObjectItem(a, cssClass = "") {
		const pathPrefix = this.tab + '.' + a.name;
		return html`
            <inspx-inspection-card class="card ${cssClass}" ?disablePhotos="${a.disablePhotos}" .inspId="${this.inspId}" .cardtitle="${a.title}"
                .data="${this.data[a.name] || {}}" .pathprefix="${pathPrefix}" .parts="${computeParts(a)}" .invalidFields="${this.validation.invalidFields}">
            </inspx-inspection-card>`;
	}

	static get properties() {
		return {
			data: Object,
			schema: Object,
			tab: String,
			validation: { type: Object },
		};
	}

	disconnectAllNestedComponents() {
		this.__reset = true;
		this.requestUpdate()
			.then(() => {
				this.__reset = false;
				this.requestUpdate();
			})
	}

	_checkInitialArrayItem() {
		const promise = (this.data.length === 1 && Object.getOwnPropertyNames(this.data[0]).length === 0)
			? store.dispatch(
				updateCurrentInspection({
					path: this.tab + ".0",
					value: {}
				}))
			: Promise.resolve();
		return promise;
	}

	addArrayItem() {
		const promise = this._checkInitialArrayItem();
		promise.then(() => {
			return store.dispatch(
				updateCurrentInspection({
					path: this.tab + "." + this.data.length,
					value: {},
					action: { name: "addArrayItem" }
				})
			).then(_ => {
				//this.updateComplete.then(_ => {

				let pp = [];
				this.shadowRoot.querySelectorAll('inspx-inspection-card').forEach(c => pp.push(c.updateComplete));
				let lastCard = this.shadowRoot.getElementById('scrollPlaceholder');
				if (lastCard)
					Promise.all(pp).then(() => {
						this.shadowRoot.querySelector('.list inspx-inspection-card:last-of-type').scrollIntoView();
					})


				//})
			});
		});
	}

	async copyArrayItem(item, ind) {
		await getUpdateInspectionPromise();
		await this._checkInitialArrayItem();

		store.dispatch(
			updateCurrentInspection({
				path: this.tab + "." + this.data.length,
				value: this.data[ind], //item,
				action: { name: "arrayItemCopy" }
			})
		);
	}

	openDeleteArrayItemConfigration(item, ind) {
		let dialog = new InspxDialog();
		dialog.cancellable = true;
		dialog.content = 'Are you sure you want to delete the item?';
		dialog.addEventListener('dialog-accept', (e) => {
			this.deleteArrayItem(item, ind);
			dialog.remove();
		});
		dialog.addEventListener('dialog-cancel', (e) => {
			dialog.remove();
		});
		document.body.appendChild(dialog);
		dialog.open();
	}

	openDeleteArrayGroupItemConfirmation(path, ind) {
		let dialog = new InspxDialog();
		dialog.cancellable = true;
		dialog.content = 'Are you sure you want to delete the item?';
		dialog.addEventListener('dialog-accept', (e) => {
			this.deleteGroupArrayItem(path, ind);
			dialog.remove();
		});
		dialog.addEventListener('dialog-cancel', (e) => {
			dialog.remove();
		});
		document.body.appendChild(dialog);
		dialog.open();
	}

	deleteGroupArrayItem(path, ind) {
		store.dispatch(updateCurrentInspection({
			path: path,
			action: { name: "deleteArrayItem", index: ind }
		}));
	}

	deleteArrayItem(item, ind) {
		store.dispatch(updateCurrentInspection({
			path: this.tab,
			action: { name: "deleteArrayItem", index: ind }
		}));
	}

	async validateCard(eventDetail) {
		const target = eventDetail.target;
		const path = eventDetail.path;

		if (!target || !path) return;

		await getUpdateInspectionPromise();

		const pathParts = path.split('.');
		const p = { tab: pathParts[0], card: pathParts[1], field: pathParts[2] };
		const isPathValid = (p.tab && p.card && p.field && this.tab === p.tab);
		if (isPathValid) {
			const isArray = this.schema.type === 'array' && Number.isInteger(Number.parseFloat(p.card));
			const cardData = this.data[p.card] || {};
			const cardSchema = isArray ? this.schema.items : this.schema.properties[p.card];
			const valResult = validateSchemaPart(cardSchema, cardData, this.insp);

			let isInvalid = false;
			if (valResult.valid) {
				if (this.validation.invalidTabs.indexOf(p.tab) > -1) {
					store.dispatch(validateCurrentInspectionTab(this.tab));
				}
			} else if (pathParts.length === 4) { // group (object)
				let dataPath = ".".concat(pathParts[2]);
				p.field = pathParts[3];
				isInvalid = (valResult.errors.findIndex(e =>
					(e.dataPath && path.endsWith(e.dataPath)) ||
                    (e.keyword === 'required' && e.dataPath === dataPath && e.params.missingProperty === p.field)) > -1);
			} else if (pathParts.length === 5) { // groupArray inside array tab
				let adaptDataPath = (dp) => (typeof dp === "string" ? dp.replace(/\[/gi, '.').replace(/\]/gi, '') : dp);
				let dataPath = ".".concat(pathParts[2], "[", pathParts[3], "]");
				p.field = pathParts[4];
				isInvalid = (valResult.errors.findIndex(e =>
					(e.dataPath && path.endsWith(adaptDataPath(e.dataPath))) ||
                    (e.keyword === 'required' && e.dataPath === dataPath && e.params.missingProperty === p.field)) > -1);
			} else {
				isInvalid = (valResult.errors.findIndex(e =>
					(e.dataPath && path.endsWith(e.dataPath)) ||
                    (e.keyword === 'required' && e.params.missingProperty === p.field)) > -1);
			}
			target.isInvalid = isInvalid;
		}
	}

	constructor() {
		super();

		this.items = [];
		this.addEventListener("inspx-input-blur", e => {
			this.validateCard(e.detail);
		});

		this.addEventListener("inspx-change", e => {
			store.dispatch(updateCurrentInspection(e.detail)).then(() => {
				this.updateComplete.then(() => this.validateCard(e.detail));
			});
		});

		this.addEventListener("delete-group-array-item", e => {
			this.openDeleteArrayGroupItemConfirmation(e.detail.path, e.detail.value)
		});

		this.addEventListener("photos-selected", e => {
			let overlay = createOverlay();
			let s = savePhotos(e.detail);
			store.dispatch(s).then(() => {
				this.imageContainerToUpdate = e.detail.container;
			})
				.finally(() => overlay.remove());
		});


		this.addEventListener("photo-delete", e => {
			store.dispatch(deletePhotoById(e.detail.id)).then(() => {
				e.detail.el.remove();
			});
		});

		this.addEventListener("drawing-delete", e => {
			store.dispatch(deleteDrawingById(e.detail.id)).then(() => {
				e.detail.el.remove();
			});
		});

		this.renderFunctions = {
			object: this.renderObject.bind(this),
			array: this.renderArray.bind(this),
			images: this.renderImages.bind(this),
			drawings: this.renderDrawings.bind(this)
		};
	}

	stateChanged(state) {
		const insp = state.inspection.current;
		const tab = state.app.route.subpage;
		this.inspId = state.app.route.id;

		if (insp && tab && tab != this.tab) {
			this.disconnectAllNestedComponents()
			this.tab = tab;
			this.schema = insp.type.schema.properties[tab];
			this.pageType = tab == "images" || tab == "drawings"
				? tab
				: this.schema.type;
		}

		if (insp && tab) {
			this.data = insp[tab] || (this.pageType === "array" ? [] : {});
		}

		this.validation = state.validation;
		this.insp = insp;
		if (this.imageContainerToUpdate) {
			this.updateComplete.then(_ => {
				this.imageContainerToUpdate.loaded = false;
				this.imageContainerToUpdate.requestUpdate().then(_ => {
					this.imageContainerToUpdate = undefined;
				})

			});
		}
	}
}

window.customElements.define("inspx-inspection", InspxInspection);
